import React from "react";
// import flatJet from "../assets/portfolio/flatjet.jpg";
import greewnWoods from "../assets/portfolio/greenwoods.jpg";
import quadzee from "../assets/portfolio/quadzee.jpg";
import playtask from "../assets/portfolio/PlayTask.png";
import bounce from "../assets/portfolio/bounce.jpg";
import monasterBash from "../assets/portfolio/MonsterBash.jpg";
import DR from "../assets/portfolio/DRU.jpg";
import HR from "../assets/portfolio/HR.webp";
import PEM from "../assets/portfolio/PEM.webp";
import BT from "../assets/portfolio/BT.webp";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: "https://play-lh.googleusercontent.com/jtlPR-zMp68K7ypV8oQNmUywOaFRQfsh13zjBGxP-CqczNQyVgdCyYmUKSXZ5GyynbI=w240-h480-rw",
      name: "Gun Painter Run",
      readmore: "https://drive.google.com/file/d/1gebraGh8q8sYaOXHMRDRAoSxR8DKrucB/view?usp=drive_link",
      productLink: "https://play.google.com/store/apps/details?id=com.Binacle.GunPainterRun&hl=en"
    },
    {
      id: 2,
      src: DR,
      name: "Demolish Run 3D",
      readmore: "https://drive.google.com/drive/folders/1IM4V_nHLxgJlUOyd5fMAzbLinPeusRIF?usp=drive_link",
      productLink: "https://play.google.com/store/apps/details?id=com.Binacle.DemolishRun3D&hl=en"
    },
    {
      id: 3,
      src: HR,
      name: "Hostage Rescue",
      readmore: "https://drive.google.com/drive/folders/1s6zL__wnqD1AqJo8QLQSVDTrWv-jlDFB?usp=drive_link",
      productLink: "https://play.google.com/store/apps/details?id=com.Binacle.HostageRescue&hl=en"
    },
    {
      id: 4,
      src: PEM,
      name: "Paint Em All",
      readmore: "https://drive.google.com/drive/folders/1hRB1jlEaNLSyssj_Xd1xILCAPAMU1TyZ?usp=drive_link",
      productLink: "https://play.google.com/store/apps/details?id=com.Binacle.PaintEmAll&hl=en"
    },
    {
      id: 5,
      src: BT,
      name: "Bendy Tracks",
      readmore: "https://docs.google.com/presentation/d/1EE_eM3VDdNeXQUGy5E1nW6rDJbd9pkBV/edit?usp=drive_link&ouid=107173232365371179003&rtpof=true&sd=true",
      productLink: "https://play.google.com/store/apps/details?id=com.Binacle.BendyTracks&hl=en"
    },
    {
      id: 6,
      src: playtask,
      name: "Play Task",
      readmore: "https://youtu.be/agDIcKDpoL0",
      productLink: "https://github.com/SanthushaMunasinghe/Play-Task.git"
    },
    {
      id: 7,
      src: quadzee,
      name: "Quad Zee",
      readmore: "https://santhushamunasinghe.itch.io/quadzee",
      productLink: "https://santhushamunasinghe.itch.io/quadzee"
    },
    {
      id: 8,
      src: bounce,
      name: "Bounce",
      readmore: "https://santhushamunasinghe.itch.io/bounce",
      productLink: "https://santhushamunasinghe.itch.io/bounce"
    },
    {
      id: 9,
      src: greewnWoods,
      name: "Dream Woods",
      readmore: "https://santhushamunasinghe.itch.io/dream-woods",
      productLink: "https://santhushamunasinghe.itch.io/dream-woods"
    },
    {
      id: 10,
      src: monasterBash,
      name: "Monster Bash",
      readmore: "https://youtu.be/PldOSW3Tsh4",
      productLink: "https://youtu.be/PldOSW3Tsh4"
    },
  ];

  return (
    <div
      name="portfolio"
      className="md:h-min-screen bg-gradient-to-b from-slate-800 to-black w-full text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({id, src, name, readmore, productLink }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <a href={productLink} target="blank">
                <img
                  src={src}
                  alt=""
                  className="w-full object-contain rounded-md duration-200 hover:scale-105"
                />
              </a>
              <div className="flex items-center justify-center">
                <p className="px-1 py-3 ml-2 my-4 duration-200 hover:scale-105">
                  <a href={readmore} target="blank"><span className="font-semibold">{name}</span> -{" "}
                  <span className="text-sm">(Read More)</span></a>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
